import React, { Component } from 'react';

import { AddIcon, CheckIcon, UserIcon } from '../images/icons';

/** Информация о состоянии этапа складского документа */
export class DocumentStatusInfo extends Component {
	render() {
		return(
			<div className={"documentStatusInfo section" +
				(this.props.ClassName ? " " + this.props.ClassName : "")}>
				<h5 className={this.props.Active ? "success" : "fail"}>
					<i className="iconSVG">
						{this.props.Active ? <CheckIcon /> : <AddIcon />}
					</i>
					{this.props.Active ? this.props.ActiveTitle : this.props.InactiveTitle}
				</h5>
				{this.props.Active &&
					<div className="user">
						<i className="iconSVG"><UserIcon /></i>
						<span>
							{this.props.User}, {this.props.Date}
						</span>
					</div>
				}
				{this.props.children}
			</div>
		)
	}
}

/** Строка дополнительной информации об этапе складского документа */
export class DocumentInfoRow extends Component {
	render() {
		return(
			<div className="documentInfoRow">
				<span className="title">{this.props.Title}</span>
				<span>{this.props.children}</span>
			</div>
		)
	}
}
